/**
 * Request-Tracker Two-Tier Whitelist
 *
 * Single source of truth for who may reach the unified request-tracker
 * surface and at what TIER. Two tiers:
 *   - DEV    (AIG): full access — internal detail + dev-side statuses.
 *   - CLIENT (Colliers): lighter — client content + client-side statuses.
 *
 * Both the frontend (route/sidebar guard, F3) and the backend transition
 * gate read these lists from @aiga/app-config/security, so visibility and
 * authorization can't diverge. The API layers its env override
 * (REQUEST_TRACKER_DEV_ALLOWLIST / REQUEST_TRACKER_CLIENT_ALLOWLIST) on top,
 * in api_backend_fastify_server/src/plugins/request-tracker-tier.ts; this
 * file's requestTrackerTier() is the baseline-only resolver the web uses.
 *
 * DEV-WINS-OVER-CLIENT: an address matching both tiers resolves to 'dev'.
 *
 * NOTE: the CLIENT lists are intentionally EMPTY until Noah populates them
 * (Matt + @colliers). Since F3a this resolver backs the release-notes proxy's
 * OUTER gate (replacing the old isEmailAllowlisted machinery), the transition
 * gate's settable_by check, and the client-visibility onSend filter — so the
 * surface stays internal-only today and admits CLIENT tier once the list is
 * filled.
 */
// DEV tier: AIG — full access. Same membership as super-admin-whitelist.ts.
export const REQUEST_TRACKER_DEV_EMAILS = [
    'aigeniustesting@gmail.com',
];
export const REQUEST_TRACKER_DEV_DOMAINS = [
    'aigeniusautomations.com',
    'aigeniusconsulting.com',
];
// CLIENT tier: Colliers. Start with Matt (Noah controls this list; add more
// Colliers people or the '@colliers.com' domain here when he opts them in).
export const REQUEST_TRACKER_CLIENT_EMAILS = [
    'matt.thrall@colliers.com',
];
export const REQUEST_TRACKER_CLIENT_DOMAINS = [];
function matches(email, emails, domains) {
    if (emails.includes(email))
        return true;
    const at = email.lastIndexOf('@');
    if (at < 0)
        return false;
    return domains.includes(email.slice(at + 1));
}
/**
 * Resolve a caller's tier. DEV wins over CLIENT: an address on both lists
 * is 'dev'. Returns null for anyone on neither list.
 */
export function requestTrackerTier(email) {
    if (!email)
        return null;
    const normalized = email.trim().toLowerCase();
    if (!normalized)
        return null;
    if (matches(normalized, REQUEST_TRACKER_DEV_EMAILS, REQUEST_TRACKER_DEV_DOMAINS)) {
        return 'dev';
    }
    if (matches(normalized, REQUEST_TRACKER_CLIENT_EMAILS, REQUEST_TRACKER_CLIENT_DOMAINS)) {
        return 'client';
    }
    return null;
}
//# sourceMappingURL=request-tracker-whitelist.js.map